'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

require('antd/lib/radio/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = _radio2.default.Group;

var RadioGroupWidget = function RadioGroupWidget(props) {
  return _react2.default.createElement(
    RadioGroup,
    {
      onChange: function onChange(e) {
        return props.onChange(e.target.value);
      },
      value: props.value,
      required: props.required,
      disabled: props.disabled
    },
    props.schema.options.map(function (_ref, index) {
      var label = _ref.label,
          value = _ref.value;
      return _react2.default.createElement(
        _radio2.default,
        { key: 'rg_' + index, value: value },
        label
      );
    })
  );
};

RadioGroupWidget.defaultProps = {
  value: '',
  disabled: false
};

RadioGroupWidget.propTypes = {
  value: _propTypes2.default.string,
  schema: _propTypes2.default.object.isRequired,
  required: _propTypes2.default.bool.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool
};

exports.default = RadioGroupWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/RadioGroupWidget/index.js
// module id = 962
// module chunks = 0